import { Module } from 'vuex';

const key = 'managerStemdoersPageFilter';
export interface StemdoersStateStorable {
  filters: { status: string[]; vertical: string[]; search: string; company: string[]; project: string[] };
}

export const defaultStemdoersState: StemdoersStateStorable = {
  filters: {
    status: undefined,
    vertical: undefined,
    search: undefined,
    company: undefined,
    project: undefined
  }
};

export const stemdoers: Module<StemdoersStateStorable, any> = {
  namespaced: true,
  state: {
    filters: localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultStemdoersState.filters
  },
  getters: {
    filters: state => getFiltersFromState(state)
  },
  mutations: {
    setStatusFilter(state, status: string[]) {
      const filters = getFiltersFromState(state);
      filters.status = status;
      persistFiltersState(state, filters);
    },
    setVerticalFilter(state, vertical: string[]) {
      const filters = getFiltersFromState(state);
      filters.vertical = vertical;
      persistFiltersState(state, filters);
    },
    setSearchFilter(state, search: string) {
      const filters = getFiltersFromState(state);
      filters.search = search;
      persistFiltersState(state, filters);
    },
    setCompanyFilter(state, company: string[]) {
      const filters = getFiltersFromState(state);
      filters.company = company;
      persistFiltersState(state, filters);
    },
    setProjectFilter(state, project: string[]) {
      const filters = getFiltersFromState(state);
      filters.project = project;
      persistFiltersState(state, filters);
    }
  }
};

const getFiltersFromState = (state): any => {
  return Object.assign({}, state.filters);
};

const persistFiltersState = (state, filters: any) => {
  state.filters = filters;
  localStorage.setItem(key, JSON.stringify(filters));
};
